/**
 * Created by jane on 17-5-3.
 */

import state from './state';
import actions from './actions';
import mutations from './mutations';

export default {
    state,
    actions,
    mutations
};
